document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.app__container').classList.add('app__container__loaded');
})
